import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { getPlayers, getLeague, getTeam, makeSubs } from '../../data';
import { CircularProgress, makeStyles } from '@material-ui/core';
import {Table, TableBody, TableCell, TableContainer, TableRow, Paper, TextField,
    Grid, Button} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckIcon from '@material-ui/icons/Check';
import { Alert, AlertTitle } from '@material-ui/lab';

function SnakeSub(props) {
    const [squad, setSquad] = useState({});

    const leagueID = props.leagueID;
    const team = props.team;
    const teamName = team.name;
    const playerBios = props.playerBios;
    const gameWeek = props.gameWeek;

    useEffect(() => {
        const f = async () => {
            const squad = await getTeam(leagueID, teamName);
            setSquad(() => squad);
        };
        f();
    }, [leagueID, teamName]);

    const playerList = gameWeek && squad[`gw${gameWeek - 1}`]
        && (squad[`gw${gameWeek - 1}`]['players']).map(p => p.id);
    if (!gameWeek || !playerList || !playerList.includes) {
        return (<TableRow></TableRow>);
    }
    const outPlayerSelector = (<Autocomplete disablePortal blurOnSelect
        className="player-picker-out"
        options={playerBios.filter(p => playerList.includes(p.id))}
        style={{ width: 200 }}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => <TextField {...params} label="Out" />} />);
    const inPlayerSelector = (<Autocomplete disablePortal blurOnSelect
        className="player-picker-in"
        options={playerBios}
        style={{ width: 200 }}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => <TextField {...params} label="In" />} />);
    return (
        <TableRow>
            <TableCell data-team={teamName}>{teamName}</TableCell>
            <TableCell>{outPlayerSelector}</TableCell>
            <TableCell>{inPlayerSelector}</TableCell>
        </TableRow>
    )
}

function Subs(props) {
    const leagueID = props.match.params.leagueID;
    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);
    const [playerBios, setPlayerBios] = useState([]);
    const [squad, setSquad] = useState([]);
    const [gameWeek, setGameWeek] = useState(undefined);
    const [error, setError] = useState(undefined);
    useEffect(() => {
        const f = async function() {
            const league = await getLeague(leagueID);
            setSquad(league['teams']);
            const bios = await getPlayers(league['tournament'], leagueID);
            setPlayerBios(bios['players']);
            setLoading(false);
        };
        f();
    }, []);

    const gameWeekChange = function() {
        const val = document.getElementById('gameweek').value;
        if (!val.startsWith('gw')) {
            setGameWeek(undefined);
            return;
        }
        const gameWeekNum = parseInt(val.replace('gw', ''));
        if (Number.isNaN(gameWeekNum)) {
            setGameWeek(undefined);
            return;
        }
        setGameWeek(gameWeekNum);
    };

    const saveSubs = async function() {
        const subsText = document.querySelector('#subs').value;
        let gameWeek = document.getElementById('gameweek').value;
        if (!gameWeek.startsWith('gw')) {
            setError(`gameweek ${gameWeek} is invalid`);
            return;
        }
        gameWeek = parseInt(gameWeek.replace('gw', ''));
        if (Number.isNaN(gameWeek)) {
            setError(`gameweek ${gameWeek} is invalid`);
            return;
        }
        const subLines = subsText.split('\n');
        const subs = [];
        setSuccess(false);
        setError(undefined);
        for (var i = 0;i < subLines.length;i++) {
            const subLine = subLines[i].trim().split(',');
            const teamName = subLine[0].trim();
            const outPlayerName = (subLine[1] || '').trim();
            const inPlayerName = (subLine[2] || '').trim();
            var outPlayerId, inPlayerId;
            outPlayerId = playerBios.filter(p => p.name.toLowerCase() === outPlayerName.toLowerCase())[0];
            inPlayerId = playerBios.filter(p => p.name.toLowerCase() === inPlayerName.toLowerCase())[0];
            if (outPlayerName.toLowerCase() === 'pass' || inPlayerName.toLowerCase() === 'pass') {
                subs.push({
                    squadName: teamName,
                    out: 'pass',
                    in: 'pass',
                });
                continue;
            }
            if (outPlayerId) {
                outPlayerId = outPlayerId['id'];
            } else {
                setError(`Unable to find ${outPlayerName} for  team ${teamName}`);
                return;
            }
            if (inPlayerId) {
                inPlayerId = inPlayerId['id'];
            } else {
                setError(`Unable to find ${inPlayerName} for  team ${teamName}`);
                return;
            }
            subs.push({
                squadName: teamName,
                out: outPlayerId,
                in: inPlayerId
            });
        }
        try {
            const response = await makeSubs(leagueID, `gw${gameWeek}`, subs);
            if (response) {
                setError(undefined);
                setSuccess(true);
            }
        } catch (err) {
            setError(`Error: ${err.message}`);
        }
    }

    const useStyles = makeStyles((theme) => ({
        root: {
            display: 'flex',
            justifyContent: 'center',
            maxWidth: 600,
        },
        table: {
            maxWidth: 600,
            alignSelf: 'center',
            flex: 'auto',
        },
        gameweek: {
            display: 'flex',
            flex: 'auto',
            maxWidth: 50,
            alignSelf: 'left',
        }
    }));
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Grid container className={classes.table} alignItems="center" spacing={2}  style={{flexShrink: 0}}>
                <Grid item xs={12}>
                {error !== undefined && <Alert severity="error" style={{flexShrink: 0}}>
                        <AlertTitle>Server Error</AlertTitle>
                        {error}
                    </Alert>}
                </Grid>
                <Grid item xs={12}>
                    {loading && <CircularProgress />}
                </Grid>
                <Grid item xs={3}>
                    <TextField id="gameweek" className={classes.gameweek} label="Gameweek" />
                </Grid>
                <Grid item>
                    <Button variant='contained' color='primary' onClick={saveSubs}>Save</Button>
                </Grid>
                <Grid item>
                    {success && <CheckIcon /> }
                </Grid>
                <Grid item xs={12}>
                    <TextField multiline={true} id="subs" placeholder="enter subs comma separated" minRows={5} style={{width: '400px'}} />
                </Grid>
            </Grid>
        </div>
    )
}
export default withRouter(Subs)